import { render, staticRenderFns } from "./RepetitionAudioSelectCourseDialog.vue?vue&type=template&id=32e7596d&scoped=true&"
import script from "./RepetitionAudioSelectCourseDialog.vue?vue&type=script&lang=ts&"
export * from "./RepetitionAudioSelectCourseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RepetitionAudioSelectCourseDialog.vue?vue&type=style&index=0&id=32e7596d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7596d",
  null
  
)

export default component.exports